
import FormRequest from './form/Request'

export default {
  FormRequest
}
